import { Button } from '../components/ui.js';

const ENABLED_OPCOS = 'Omni CleanAir, Sportworks, Bird Buffer';

export function Header() {
  return (
    <header className="flex items-center justify-between py-4">
      <div>
        <h1 className="text-[18px] font-medium">Link filter</h1>
        <p className="text-[13px]" style={{ color: 'var(--text-secondary)' }}>
          {ENABLED_OPCOS}
        </p>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" size="md">
          New link
        </Button>
        <Button variant="outline" size="md">
          Settings
        </Button>
      </div>
    </header>
  );
}
